<form
    nz-form
    nzLayout="vertical"
    [formGroup]="calculatorForm"
    #calculatorFormEl>
    <nz-form-item *ngIf="message$ | async as message">
        <nz-alert
            [nzMessage]="message.text"
            [nzType]="message.type"></nz-alert>
    </nz-form-item>

    <nz-form-item>
        <nz-form-label>{{ wts.getI18nLabel(i18nFormFieldsPath, 'amount.label') }}</nz-form-label>

        <nz-radio-group
            class="ant-radio-group-items"
            formControlName="amount"
            (ngModelChange)="onAmountChange($event)">
            <label
                *ngFor="let amount of amountItems"
                nz-radio
                [nzValue]="amount"
                [nzDisabled]="amount < minNumber || amount > maxNumber">
                <span class="ant-radio-title">{{ pricePerShare * amount | price }}</span>
                <span class="ant-radio-description">{{ amount | i18nPlural : shareMapping }}</span>
            </label>
        </nz-radio-group>
    </nz-form-item>

    <nz-form-item>
        <div class="invest__label">{{ wts.getI18nLabel(i18nFormFieldsPath, 'numberOfShares.label') }}</div>

        <div class="share-picker">
            <button
                class="share-picker__btn share-picker__btn-left"
                nz-button
                [disabled]="calculatorForm.controls.numberOfShares.value <= minNumber || calculatorForm.controls.numberOfShares.value === 0"
                (click)="decreaseShares()">
                <i class="icon icon-minus"></i>
            </button>

            <nz-input-number
                class="share-picker__input"
                formControlName="numberOfShares"
                [nzPrecision]="0"
                [nzDisabled]="calculatorForm.controls.numberOfShares.value === 0"
                [class.share-picker__input-error]="
                    calculatorForm.controls.numberOfShares.value &&
                    (calculatorForm.controls.numberOfShares.value < minNumber || calculatorForm.controls.numberOfShares.value > maxNumber)
                "
                (ngModelChange)="onNumberOfSharesChange($event)"
                (nzBlur)="checkNumberOfShares()"
                (keyup.enter)="checkNumberOfShares()"></nz-input-number>

            <button
                class="share-picker__btn share-picker__btn-right"
                nz-button
                [disabled]="calculatorForm.controls.numberOfShares.value >= maxNumber || minNumber > maxNumber"
                (click)="increaseShares()">
                <i class="icon icon-plus"></i>
            </button>
        </div>
    </nz-form-item>
    <br />

    <nz-form-item>
        <nz-form-label>
            {{ wts.getI18nLabel(i18nFormFieldsPath, 'frequency.label') }}
        </nz-form-label>

        <nz-radio-group
            class="ant-radio-group-items"
            formControlName="frequency">
            <label
                nz-radio
                [nzValue]="FREQUENCY.Weekly">
                <span class="ant-radio-title">
                    {{ wts.getI18nLabel(i18nFormFieldsPath, 'frequency.options.weekly.title') }}
                </span>

                <span class="ant-radio-description">
                    {{ wts.getI18nLabel(i18nFormFieldsPath, 'frequency.options.weekly.description') }}
                </span>
            </label>

            <label
                nz-radio
                [nzValue]="FREQUENCY.Monthly">
                <span class="ant-radio-title">
                    {{ wts.getI18nLabel(i18nFormFieldsPath, 'frequency.options.monthly.title') }}
                </span>

                <span class="ant-radio-description">
                    {{ wts.getI18nLabel(i18nFormFieldsPath, 'frequency.options.monthly.description') }}
                </span>
            </label>
        </nz-radio-group>
    </nz-form-item>
    <br />

    <div class="invest__calc">
        <h3>
            {{ wts.getI18nLabel(i18nFormCalcPath, 'title') }}
        </h3>

        <div
            nz-row
            nzGutter="30">
            <div
                nz-col
                nzXs="12"
                nzMd="6">
                <nz-form-item>
                    <nz-form-label nzFor="return">
                        {{ wts.getI18nLabel(i18nFormFieldsPath, 'return.label') }}
                    </nz-form-label>

                    <nz-form-control nzErrorTip="{{ wts.getI18nLabel(i18nFormFieldsPath, 'return.error') }}">
                        <nz-input-number
                            formControlName="return"
                            id="return"
                            tabindex="3"
                            [nzPrecision]="0"
                            [nzFormatter]="formatterPercent"
                            [nzMin]="1"
                            [nzMax]="100"></nz-input-number>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div
                nz-col
                nzXs="12"
                nzMd="6">
                <nz-form-item>
                    <nz-form-label nzFor="horizon">
                        {{ wts.getI18nLabel(i18nFormFieldsPath, 'horizon.label') }}
                    </nz-form-label>

                    <nz-form-control>
                        <nz-select
                            formControlName="horizon"
                            id="horizon">
                            <nz-option
                                nzLabel="10"
                                nzValue="10"></nz-option>

                            <nz-option
                                nzLabel="20"
                                nzValue="20"></nz-option>

                            <nz-option
                                nzLabel="30"
                                nzValue="30"></nz-option>

                            <nz-option
                                nzLabel="40"
                                nzValue="40"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div
                nz-col
                nzXs="12">
                <nz-form-item>
                    <nz-form-label>
                        {{ wts.getI18nLabel(i18nFormCalcPath, 'chart.title') }}
                    </nz-form-label>

                    <p>
                        {{ wts.getI18nLabel(i18nFormCalcPath, 'chart.description', {
                                amount: calculatorForm.controls.numberOfShares.value * pricePerShare,
                                frequency: calculatorForm.controls.frequency.value.toLowerCase(),
                                horizon: calculatorForm.controls.horizon.value,
                                return: calculatorForm.controls.return.value,
                        }) }}
                    </p>
                </nz-form-item>
            </div>

            <div
                class="invest__chart"
                nz-col
                nzXs="12">
                <canvas
                    baseChart
                    [data]="barChartData"
                    [options]="barChartOptions"
                    [type]="'bar'"></canvas>
            </div>

            <ng-container *ngIf="compoundRevenue; else noCompoundRevenue">
                <div
                    nz-col
                    nzXs="12"
                    nzMd="6">
                    <div class="invest__row">
                        <span class="invest__name">
                            {{ wts.getI18nLabel(i18nFormCalcPath, 'table.contribution') }}
                        </span>

                        <span class="invest__amount">{{ compoundRevenue?.recurringContributionValueCents / 100 | price }}</span>
                    </div>

                    <div class="invest__row">
                        <span class="invest__name">
                            {{ wts.getI18nLabel(i18nFormCalcPath, 'table.total', { horizon: calculatorForm.controls.horizon.value }) }}
                        </span>

                        <span class="invest__amount">{{ compoundRevenue?.totalInvestmentCents / 100 | price }}</span>
                    </div>

                    <div class="invest__row">
                        <span class="invest__name">{{ wts.getI18nLabel(i18nFormCalcPath, 'table.portfolio') }}</span>

                        <span class="invest__amount">{{ compoundRevenue?.finalPortfolioValueCents / 100 | price }}</span>
                    </div>
                </div>

                <div
                    nz-col
                    nzXs="12"
                    nzMd="6">
                    <div class="invest__row">
                        <span class="invest__name">{{ wts.getI18nLabel(i18nFormCalcPath, 'table.growth') }}</span>

                        <span class="invest__amount">{{ compoundRevenue?.totalGrowthFromTheMarketCents / 100 | price }}</span>
                    </div>

                    <div class="invest__row">
                        <span class="invest__name">{{ wts.getI18nLabel(i18nFormCalcPath, 'table.share') }}</span>

                        <span class="invest__amount">{{ compoundRevenue?.shareOfWealthCreatedByCompounding }}%</span>
                    </div>
                </div>
            </ng-container>

            <ng-template #noCompoundRevenue>
                <nz-skeleton
                    [nzActive]="true"
                    [nzParagraph]="{ rows: 3 }"></nz-skeleton>
            </ng-template>

            <div
                nz-col
                nzXs="12">
                <p class="invest__note">
                    {{ wts.getI18nLabel(i18nFormCalcPath, 'note') }}
                </p>
            </div>
        </div>
    </div>
</form>
